import { Box, BoxProps } from "@mui/material";
import React from "react";
import { PropsWithChildren } from "react";

export type RotateElementProps = PropsWithChildren<
  BoxProps & {
    rotate: string;
    onClick?: () => void;
  }
>;

export const RotateElement: React.FC<RotateElementProps> = ({
  rotate,
  onClick,
  children,
}) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        rotate: rotate,
      }}
    >
      {children}
    </Box>
  );
};
